import RecipientVariablesList from './RecipientVariablesList';

export default RecipientVariablesList;
